export default function EmptyBSZState() {
  return <div>Keine Information verfügbar</div>;
}
